import { render } from "./MainLayout.vue?vue&type=template&id=0e5095b4"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"

import "./MainLayout.vue?vue&type=style&index=0&id=0e5095b4&lang=css"

import exportComponent from "/www/wwwroot/appiary.onesta.co.id/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__